import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CaseService } from 'src/app/shared/services/case.service';
import { faLink } from '@fortawesome/pro-light-svg-icons';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-linked-cases',
  templateUrl: './linked-cases.component.html',
  styleUrls: ['./linked-cases.component.scss']
})
export class LinkedCasesComponent {

_caseId!: number;

  @Input()
  set caseId(value: number) {
    this._caseId = value;
    this.loadLinkedCases();
  }
  get caseId() :number {
    return this._caseId;
  }

 faLink = faLink;

  links: any[] = [];
  refreshSubscription: Subscription;

  constructor( private caseService: CaseService, public router: Router) {

     this.refreshSubscription = this.caseService.refreshCaseObservable.subscribe(() => {
      this.loadLinkedCases();
    });
  }


 loadLinkedCases() {

  if (!this._caseId) return;

      this.caseService.getLinkedCases(this.caseId).subscribe(result => {

        this.links = result.filter((l: any) => l.instructedDate);

    }, error => {

      var errorMessage = "Failed to get links";
      if (error.error !== null && error.error.message !== undefined) {
        errorMessage = error.error.message;
      }

    });
  }

  gotoCase(id: number) {
    this.router.navigate(['/', 'case', id]);
  }

  ngOnDestroy() {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }


}
